export default __webpack_public_path__ + "static/media/Tissot_The_Flight_of_the_Prisoners.f8398c98.jpg";